const allowedProtocols = ['https:'];

// Hard browser navigation boundary. Resolves the target (relative paths resolve against the
// current origin) and only navigates to https URLs, so a malicious `javascript:` or `data:`
// scheme can never reach window.location.assign as a DOM-XSS / open-redirect vector.
export function redirect(url) {
    const parsed = new URL(url, window.location.origin);

    if (!allowedProtocols.includes(parsed.protocol)) {
        throw new Error(`Refusing to redirect to an unsupported URL scheme: ${parsed.protocol}`);
    }

    window.location.assign(url);
}
